<script setup>
// catalogue page does not exist (yet)
clearError({ redirect: '/' })
</script>

<template>
  <div v-if="false" />
</template>

<style lang="scss" scoped></style>
